import OpeningHours from "features/OpeningHours/OpeningHours";

const OpeningHoursPage: React.FC = () => {
  return <OpeningHours />;
};

export default OpeningHoursPage;
